import React from 'react';
import { UserAvatar } from '@components/Community/index.js';
import { IconLogout, IconSettings, IconRosetteDiscountCheckFilled, IconSun, IconMoon, IconDeviceDesktop } from "@tabler/icons-react";
import { Text, ButtonGroup } from '@fragments';
import { appVersion, termsUrl } from '@config';
import './dropdown.scss';

export default function UserDropdown({ user, appearance, onChangeTheme, onOpenProfile, onLogout }) {
    return (
        <div className="usd-panel">
            {/* User card */}
            <div className="usd-user-card">
                <UserAvatar user={user} size={44} />
                <div className="usd-user-info">
                    <div className="usd-username-row">
                        <Text.span weight={500} contrast={10}>{user?.username}</Text.span>
                        {user?.verified ? (
                            <IconRosetteDiscountCheckFilled size={16} className="usd-verified-icon" />
                        ) : null}
                    </div>
                    <Text.span contrast={6} className="usd-sub-text">
                        {user?.nickname ? `@${user?.nickname}` : user?.email?.address}
                    </Text.span>
                </div>
            </div>

            <div className="usd-divider" />

            {/* Appearance row */}
            <div className="usd-row usd-row--no-hover">
                <Text.span contrast={7}>Aparência</Text.span>
                <ButtonGroup
                    size="small"
                    value={appearance}
                    onChange={onChangeTheme}
                    options={[
                        { value: 'light',  icon: <IconSun  size={15} /> },
                        { value: 'system', icon: <IconDeviceDesktop size={15} /> },
                        { value: 'dark',   icon: <IconMoon size={15} /> },
                    ]}
                />
            </div>

            <div className="usd-divider" />

            {/* Settings */}
            <button className="usd-row usd-row--button" onClick={onOpenProfile}>
                <div className="usd-row-left">
                    <Text.span left={<IconSettings />} contrast={9}>Configurar Perfil</Text.span>
                </div>
            </button>

            <div className="usd-divider" />

            {/* Logout */}
            <button className="usd-row usd-row--button usd-row--danger" onClick={onLogout}>
                <div className="usd-row-left">
                    <Text.span left={<IconLogout />} contrast={9}>Sair</Text.span>
                </div>
            </button>

            {/* Footer */}
            <div className="usd-footer">
                <Text.span contrast={5} className="usd-footer-text">
                    v{appVersion} · <a href={termsUrl} target="_blank" rel="noreferrer">Termos &amp; Condições</a>
                </Text.span>
            </div>
        </div>
    );
}
